@if (moduleType === 1) {
  <div bsModal #propertyProtectionModal="bs-modal" [config]="modalConfig" class="modal fade" id="PropertyProtectionModal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal_400" role="document">
      <div class="modal-content">
        <form class="modify_rental_lft" [formGroup]="PropertyProtectionForm">
          <div class="modal-header">
            <h5 class="modal-title">{{propertyProtectionLabel}}@if (propertyProtectionField) {
              <span class="required"
              >*</span>
            }</h5>
            <button type="button" class="close" aria-label="Close"
              (click)="cancelPropertyProtection(); closeModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row mx-0 mt-2">
              <select class="form-select" formControlName="PropertyProtection" (change)="onChangePP($event)">
                @for (item of CustomerPropertyProtectionList; track item) {
                  <option [value]="item.Id"
                    [disabled]="facilityMoveInSettings?.MakeInsuranceMandatory && item.Id == EPropertyProtectionId.None"
                  [selected]="item.SelectedInsurance">{{item.Name}}</option>
                }
              </select>
              @if (PropertyProtectionForm.get('PropertyProtection').errors  && (PropertyProtectionForm.get('PropertyProtection').dirty || PropertyProtectionForm.get('PropertyProtection').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (PropertyProtectionForm.get('PropertyProtection').errors.required) {
                    <span>
                    {{propertyProtectionLabel}} is required</span>
                  }
                </div>
              }
            </div>
            <div class="row mx-0 mt-3">
              <label class="w-100">Balance@if (balanceField) {
                <span class="required">*</span>
              }</label>
              <input type="text" class="form-control" formControlName="Balance" readonly />
              @if (PropertyProtectionForm.get('Balance').errors  && (PropertyProtectionForm.get('Balance').dirty || PropertyProtectionForm.get('Balance').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (PropertyProtectionForm.get('Balance').errors.required) {
                    <span>
                    Balance is required</span>
                  }
                </div>
              }
            </div>
            <div class="row mx-0 mt-3">
              <label class="w-100">Policy #@if (PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance) {
                <span class="required"
                >*</span>
              }</label>
              <input type="text" class="form-control" formControlName="PolicyNo" maxlength="25" />
              @if (PropertyProtectionForm.get('PolicyNo').errors  && (PropertyProtectionForm.get('PolicyNo').dirty || PropertyProtectionForm.get('PolicyNo').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (PropertyProtectionForm.get('PolicyNo').errors.required) {
                    <span>
                    Policy # is required</span>
                  }
                </div>
              }
            </div>
            <div class="row mx-0 mt-3">
              <label class="w-100">Company Name@if (PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance) {
                <span class="required"
                >*</span>
              }</label>
              <input type="text" class="form-control" formControlName="CompanyName" maxlength="50" />
            </div>
            <div class="row mx-0 mt-3">
              <label class="w-100">Expiry Date@if (PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance) {
                <span class="required"
                >*</span>
              }</label>
              <ejs-datepicker class="form-control mt-2 p-0 h-auto" [max]='expEndDate'
                formControlName="ExpiryDate"
                [enabled]="PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance"
                format='MM/dd/yyyy' floatLabelType='Always' [allowEdit]='false'>
              </ejs-datepicker>
            </div>
            <div class="row mx-0 mt-3">
              <div class="md-radio">
                <input id="1" type="radio" class="form-control" value="1" formControlName="DateOption"
                  (click)="onchangePPDateOption(1)">
                  @if (!futureMovedIn) {
                    <label for="1">Today@if (todayField) {
                      <span class="required">*</span>
                    }</label>
                  }
                  @if (futureMovedIn) {
                    <label for="1">Effective Future Move In Date@if (todayField) {
                      <span class="required"
                      >*</span>
                    }</label>
                  }
                </div>
              </div>
              <div class="row flex-column mx-0 mt-3">
                <div class="md-radio">
                  <input id="2" type="radio" class="form-control" value="2" formControlName="DateOption"
                    (click)="onchangePPDateOption(2)">
                    <label for="2">Effective Date@if (effectiveDateField) {
                      <span class="required">*</span>
                    }</label>
                  </div>
                  @if (PropertyProtectionForm.get('DateOption').value == 1) {
                    <input type="text" class="form-control mt-2"
                      [value]="PropertyProtectionForm.get('EffectiveDate').value | date: 'MM/dd/yyyy' " readonly />
                  }
                  @if (PropertyProtectionForm.get('DateOption').value == 2) {
                    <ejs-datepicker class="form-control mt-2 p-0 h-auto" id="effDatePropPtn1"
                      [allowEdit]="false"
                      formControlName="EffectiveDate" (renderDayCell)="onLoadEffectiveDate($event)" [min]="today"
                      format='MM/dd/yyyy' floatLabelType='Always'>
                    </ejs-datepicker>
                  }
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary me-3"
                (click)="cancelPropertyProtection(); closeModal()">Cancel</button>
                <button type="button" class="btn btn-primary" [disabled]="disableSave()"
                (click)="savePropertyProtection(); closeModal()">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    }


    @if (moduleType === 2) {
      <div>
        <form class="modify_rental_lft" [formGroup]="PropertyProtectionForm">
          <div class="row mx-0 mt-2">
            <select class="form-select" formControlName="PropertyProtection" (change)="onChangePP($event)">
              @for (item of CustomerPropertyProtectionList; track item) {
                <option [value]="item.Id"
                  [disabled]="facilityMoveInSettings?.MakeInsuranceMandatory && item.Id == EPropertyProtectionId.None"
                [selected]="item.SelectedInsurance">{{item.Name}}</option>
              }
            </select>
          </div>
          <div class="row mx-0 mt-3">
            <label class="w-100">Balance</label>
            <input type="text" class="form-control" formControlName="Balance" readonly />
          </div>
          <div class="row mx-0 mt-3">
            <label class="w-100">Policy #@if (PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance) {
              <span class="required"
              >*</span>
            }</label>
            <input type="text" class="form-control" formControlName="PolicyNo" (keyup)="subjectPolicyNo.next($event)" />
          </div>
          <div class="row mx-0 mt-3">
            <label class="w-100">Company Name@if (PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance) {
              <span class="required"
              >*</span>
            }</label>
            <input type="text" class="form-control" formControlName="CompanyName" (keyup)="subjectCompanyName.next($event)" />
          </div>
          <div class="row mx-0 mt-3">
            <label class="w-100">Expiry Date@if (PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance) {
              <span class="required"
              >*</span>
            }</label>
            <ejs-datepicker class="form-control mt-2 p-0 h-auto" [min]="minDate" [max]='expEndDate' formControlName="ExpiryDate"
              format='MM/dd/yyyy'
              [enabled]="PropertyProtectionForm.get('PropertyProtection').value == EPropertyProtectionId.ProofOfInsurance"
              floatLabelType='Always' [allowEdit]='false' (change)="changeExpiryDate($event)">
            </ejs-datepicker>
          </div>
          <div class="row mx-0 mt-3">
            <div class="md-radio">
              <input id="1" type="radio" class="form-control" value="1" formControlName="DateOption"
                (click)="onchangePPDateOption(1)">
                @if (!futureMovedIn) {
                  <label for="1">Today</label>
                }
                @if (futureMovedIn) {
                  <label for="1">Effective Future Move In Date</label>
                }
              </div>
            </div>
            <div class="row flex-column mx-0 mt-3">
              <div class="md-radio">
                <input id="2" type="radio" class="form-control" value="2" formControlName="DateOption"
                  (click)="onchangePPDateOption(2)">
                  <label for="2">Effective Date</label>
                </div>
                @if (PropertyProtectionForm.get('DateOption').value == 1) {
                  <input type="text" class="form-control mt-2"
                    [value]="PropertyProtectionForm.get('EffectiveDate').value | date: 'MM/dd/yyyy' " readonly />
                }
                @if (PropertyProtectionForm.get('DateOption').value == 2) {
                  <ejs-datepicker class="form-control mt-2 p-0 h-auto" id="effDatePropPtn2"
                    [allowEdit]="false" formControlName="EffectiveDate"
                    [min]="today" (change)="changeDate($event)" (renderDayCell)="onLoadEffectiveDate($event)" format='MM/dd/yyyy'
                    floatLabelType='Always'>
                  </ejs-datepicker>
                }
              </div>
            </form>
          </div>
        }